<template>
  <section-box class="mb-100">
    <notes-default :noteable="contact"></notes-default>
  </section-box>
</template>

<script>
export default {
  name: "ContactNotes",
  computed: {
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        id: null,
        class_name: null,
      };
    },
  }
}
</script>
